<div class="cart-item-wrapper">
  <div class="cart-item">
    <div class="content w-100">

      <app-product-image-wrapper [slug]="orderLine ? orderLine.productVariant.product?.slug : product?.slug">
        <div class="img-wrapper">
          @if(orderLine){

          @if(orderLine.featuredAsset){
          <img [src]="orderLine.featuredAsset | assetPreview:'thumb'" [alt]="orderLine.productVariant.name" />
          } @else {
          <img src="./.../../../../../../../../assets/images/placeholders/no-img-placeholder.svg"
            [alt]="orderLine.productVariant.name">
          }


          }
          @if(product){
          @if(orderLine.featuredAsset){
          <img [src]="product.imageUrl" [alt]="'product-img'" />
          } @else {
          <img src="./.../../../../../../../../assets/images/placeholders/no-img-placeholder.svg"
            [alt]="'product-image'">
          }

          }
        </div>
      </app-product-image-wrapper>
      @if(orderLine){
      <app-product-details-header [name]="orderLine.productVariant?.name"
        [slug]="orderLine.productVariant?.product?.slug"
        [manufacturer]="orderLine.productVariant?.product?.customAttributes?.manufacturer"
        [sku]="orderLine.productVariant?.sku" [small]="true" [discounts]="orderLine?.discounts">
      </app-product-details-header>
      }

    </div>
    @if(inOrder){
    <p-menu [styleClass]="'standart-p-menu'" #orderActionsMenu [model]="orderActions" [popup]="true"
      [appendTo]="'body'"></p-menu>
    <button (click)="orderActionsMenu.toggle($event)" pButton pRipple
      class="c-button icon-only table-action-btn p-unset-xxl">
      <img src="./../../../../../../assets/images/icons/more_horiz.svg" alt="delete">
    </button>
    } @else {
    @if(orderLine){
    <app-delete-cart-item-btn-block [orderLine]="orderLine"></app-delete-cart-item-btn-block>

    } @else {
    <button pButton pRipple class="c-button icon-only table-action-btn p-unset-xxl">
      <img src="./../../../../../../assets/images/icons/delete_forever.svg" alt="delete">
    </button>
    }
    }
  </div>
  @if(orderLine){
  <app-delivery-item-actions-block [orderLine]="orderLine" [inOrder]="inOrder" [order]="order">
  </app-delivery-item-actions-block>
  } @else {
  <app-delivery-item-actions-block [product]="product" [inOrder]="inOrder"></app-delivery-item-actions-block>
  }

  <div class="stock-line">
    @if(stockLevel > 0){
    <p>{{stockLevel}} in stock at supplier warehouse</p>
    } @else {
    <p><b>Sold out</b></p>
    }


  </div>
</div>
